import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccessibleRouteDTO } from "../../../types/routes";

/**
 * 🧭 Estado global para rutas accesibles
 */
export interface IRoutesState {
  /** Lista de rutas accesibles disponibles */
  routes: AccessibleRouteDTO[];

  /** Indica si está en proceso de búsqueda */
  isLoading: boolean;
}

/** 🧱 Estado inicial */
const initialState: IRoutesState = {
  routes: [],
  isLoading: false,
};

export const routesSlice = createSlice({
  name: "routes",
  initialState,
  reducers: {
    /**
     * 🔹 Iniciar el estado de carga (antes de buscar rutas)
     */
    startLoadingRoutes: (state) => {
      state.isLoading = true;
    },

    /**
     * 🔹 Cargar la lista completa de rutas accesibles
     */
    setAccessibleRoutes: (state, action: PayloadAction<AccessibleRouteDTO[]>) => {
      state.routes = action.payload;
      state.isLoading = false;
    },

    /**
     * 🧹 Limpiar todas las rutas cargadas
     */
    clearAccessibleRoutes: (state) => {
      state.routes = [];
      state.isLoading = false;
    },

    /**
     * ⚙️ Establecer manualmente el estado de carga
     * (permite controlarlo desde componentes como SearchInputField)
     */
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

// =====================================================
// 📤 EXPORTAR ACTIONS
// =====================================================
export const {
  startLoadingRoutes,
  setAccessibleRoutes,
  clearAccessibleRoutes,
  setLoading,
} = routesSlice.actions;

// =====================================================
// 📤 EXPORTAR REDUCER
// =====================================================
export default routesSlice.reducer;
